import React, { Component, useEffect } from 'react'
import Tooltip from '@mui/material/Tooltip'
import { Row } from '../rows'
import Switch from '@mui/material/Switch'
import Button from '@mui/material/Button'
import { SocketContext } from './../contexts/socket';
import { FormControlLabel, FormGroup, Stack, Grid, Typography } from '@mui/material';
import FileTable from './file_table'
import { MAX_WIDTH } from '../App';
import { Levels, useISUContext } from '../pages/Gui/gui';
import FitsViewer from './fits_viewer/fits_viewer'
import Skeleton from '@mui/material/Skeleton';
import FileViewer from './file_viewer'
import LevelMenu from './level_menu'
import { useAuth } from '../contexts/AuthContext'

import ReactGA from 'react-ga4';

import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Link from '@mui/material/Link';
import KeyIcon from '@mui/icons-material/Key';
import downloadAnimation from './downloading.gif';
import { get_file } from '../api'

const IS_KOA: boolean = process.env.REACT_APP_ENVIRONMENT === 'koa'
interface Props {
}


interface NewFile {
    bytesRead: ArrayBuffer
    metadata: Row
    viewOnly?: boolean
    downloadurl?: string
    downloadmethod?: string
}

export const SocketTable = function (props: Props) {
    const [rows, setRows] = React.useState([] as Row[])
    const [currentRow, setCurrentRow] = React.useState(undefined as unknown as Row)
    const [fitsAB, setFitsAB] = React.useState(undefined as unknown as ArrayBuffer)
    const [openFileViewer, setOpenFileViewer] = React.useState(false)
    const [loading, setLoading] = React.useState(true);
    const [tableFilters, setTableFilters] = React.useState({});
    const [wgetDownloadProgress, setWgetDownloadProgress] = React.useState({'status': 'done'});
    const [ingestCount, setIngestCount] = React.useState(0);
    const socket = React.useContext(SocketContext);
    const isu = useISUContext()
    const { token, user, watchDate } = useAuth()

    useEffect(() => {
        if (token) {
            create_connections(isu.levels, isu.downloadFilenames)
        }
    }, [token])

    useEffect(() => {
        create_connections(isu.levels, isu.downloadFilenames)
    }, [isu.levels, isu.downloadFilenames, token])
    
    const stream_data = (row: Row, u_token: string) => {
        const auth_row = {...row, token:u_token}
        socket.emit('request_file', auth_row, isu.downloadFilenames)
    }

    const create_connections = React.useCallback((levels: Levels, downloadFilenames: boolean) => {
        const receive_metadata_event_listener = (row: Row) => {
            //listens for one row. updats table with this row on top.
            row.userid = user?.userid;
            // row.ofname_flag = isu.downloadFilenames.ofname ;
            // if ( !(row.ingestType == 'lev0' && row.filename.match('.*.jpg')) ) {
            if ( !(row.filename.match('.*.jpg')) ) {
                if ( (row.semid.match('.*.ENG') && row.propint == 0) || (! row.semid.match('.*.ENG')) ) {

			setRows((rows) => [row, ...rows])
			setLoading(false)
			//check if toggle is on and level is selected
			const requestFile = levels[row.ingestType] === true
			//Temporarily allow all ingest types
			if (levels[row.ingestType]) {
			    stream_data(row, token)
			}
                }
            }
        }

        socket.removeListener('receive_metadata_event')
        socket.on('receive_metadata_event', receive_metadata_event_listener)

        const receive_metadata_listener = (newRows: Row[]) => {
            // listens for multiple rows. replaces table with this array of rows
            setLoading(false)
            setRows(newRows)
    
            if ( newRows[0] ) {
              const current_utdate = newRows[0].utdate;
	      ReactGA.event('New Ingestion', {
	        event_category: 'Streams',
	        action: 'new_ingestion',
	        event_label: current_utdate,
	        value: 1
	      });
            }
        }

        socket.removeListener('receive_metadata')
        socket.on('receive_metadata', receive_metadata_listener)

        const receive_new_file_listener = (msg: NewFile) => {
            const row = msg.metadata
            const viewOnly = msg.viewOnly
            let link = document.createElement('a')
            // Download via downloadurl
            const download_url = msg.downloadurl ? msg.downloadurl : '' ;
            link.href = download_url.replace(/^\//, "");

            isu.setImgSrc(link.href as string) //set for img viewer

            const _ofname = ( row['ofname'] && row['ofname'] != "null" && row['ofname'] != "" ) ? row['ofname'] : row['filename']
            const row_filename = downloadFilenames ? _ofname : row['filename'] 
            // Preferred filename n=preferred name.
            if ( downloadFilenames ) {
               link.href = link.href + `?n=${_ofname}`

               const file_ = get_file(download_url, token, isu.downloadFilenames);
               console.log(file_);
            }
            link.setAttribute('download', row_filename);

            if (!viewOnly) { // download file
                link.click()
                link.remove() //needed to avoid downloading twice on firefox.
                ReactGA.event('Downloads', {
		  event_category: 'File Downloads',
		  action: 'new_download',
                  event_label: `${row_filename}`,
                  value: 1
		});
            }
        }

        socket.on('wget_delivery_in_progress', function(data_: any) { })

        socket.removeListener('receive_new_file')
        socket.on('receive_new_file', receive_new_file_listener)
        // Added token to dependency to ensure CallBack contains latest token
    }, [token])

    const handleScriptDownload = () => {

        const req = {}
        if (token) {
            setWgetDownloadProgress({'status': 'inprogress'});
            socket.emit('request_wget', token, [isu.downloadFilenames, tableFilters])
            socket.on('wget_delivery_complete', ( wget_status:any ) => {
                 setWgetDownloadProgress(wget_status);
            })
        }
        // socket.emit('request_wget', token, ofname_flag)
    }

    const handleDownloadFilenameSelection = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.value === "koaid") {
            isu.setDownloadFilenames(false)
        }
        else {
            isu.setDownloadFilenames(true)
        }
    }


    return (
        <div style={{
            margin: '8px',
            marginLeft: 'auto',
            marginRight: 'auto',
            maxWidth: MAX_WIDTH
        }}>
            <FormGroup>
                <Stack sx={{ marginBottom: '4px' }} direction="row" spacing={2} className="no-print">
                    <div>
                        <Tooltip placement={'right'} title={'Select file level(s) to download'}>
                            <>
                                <LevelMenu />
                            </>
                        </Tooltip>
                            <FormControl sx={{ borderLeft: '1px solid', marginLeft: '1em', paddingLeft: '1em', borderRight: '1px solid', marginRight: '1em', paddingRight: '1em' }}>
                                <RadioGroup
                                    row
                                    value={isu.downloadFilenames ? "ofname" : "koaid"}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                        handleDownloadFilenameSelection(event)
                                    }}
                                >
                                    <Tooltip placement={'right'} title={'Select this option to assign OFNAME as filename'}>
                                        <FormControlLabel value="ofname" control={<Radio />} label="OFNAME" />
                                    </Tooltip>
                                    <Tooltip placement={'right'} title={'Select this option to assign KOAID as filename'}>
                                        <FormControlLabel value="koaid" control={<Radio />} label="KOAID" />
                                    </Tooltip>
                                </RadioGroup>
                            </FormControl>
                    </div>
                    {/* {currentRow && (
                        <FileViewer open={openFileViewer} setOpen={setOpenFileViewer} fitsAB={fitsAB} currentRow={currentRow} imgSrc={isu.imgSrc} />
                    )} */}
                </Stack>
            </FormGroup>
            <React.Fragment>
                {loading ? (
                    <>
                        <Typography sx={{ marginTop: '1em' }} variant="h6">Waiting on stream to begin.</Typography>
                        <Skeleton
                            sx={{ bgcolor: 'yellow', maxWidth: MAX_WIDTH }}
                            variant="text"
                            width={"100%"}
                            height={60}>
                        </Skeleton>
                    </>
                ) : (<></>)
                }
		<Grid container spacing={1} direction="row" alignItems="center" className="home_info_bar" style={{ marginTop: '1em', borderTop: '1px solid #444', paddingTop: '1em', paddingBottom: '1em' }}>
		    <Grid item xs={8}>
                        <Typography style={{display: 'inline-block', marginRight: '2em'}}>Observation Date (UT): <span>{watchDate}</span></Typography>
                        <Typography style={{display: 'inline-block', marginRight: '2em'}}>Ingest Count: <span>{rows.length}</span></Typography>
                    </Grid>
				    <Grid item xs={4} style={{display: 'flex', justifyContent: 'flex-end'}}>
		            <Link href='https://koa.ipac.caltech.edu/applications/KOA/grant.html' target='blank' style={{display: 'flex', justifyContent: 'end'}}>
					 <span style={{ paddingRight: '.5em'}}>Grant User Access</span> 
					 <KeyIcon/>
                            </Link>
				    </Grid>
                </Grid>
                <FileTable rows={rows}/>
            </React.Fragment>
                <div style={{padding: "2em"}}>
                    <p>&nbsp;</p>
                </div>
        </div >
    )
}
